import { NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TenantUsersDto } from '@buspro/web/apis';

@Component({
  selector: 'tenant-brand',
  templateUrl: './brand.component.html',
  styleUrls: ['./brand.component.scss'],
  imports: [RouterLink, NgIf],
  standalone: true,
})
export class BrandComponent {
  @Input() authUser: TenantUsersDto | null = null;
  @Input() isCollapsed = false;
  /** Use 'white' for light logo on blue sidebar (light mode); 'color' for full-color logo (dark mode, mobile drawer). */
  @Input() logoVariant: 'color' | 'white' = 'color';

  get hasCompanyLogo(): boolean {
    return !!this.authUser?.company?.logoUrl;
  }

  get companyName(): string {
    return this.authUser?.company?.name || '';
  }
}
